module.exports = __webpack_public_path__ + "static/img/gift-9.9d788cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-9.png
// module id = 369
// module chunks = 140